module.exports = __webpack_public_path__ + "static/media/video-call-full.33de44a7.png";